(function () {
    'use strict';

    var module = angular.module('imApp');

    module.factory('stateService', [
        '$state',
        '$q',
        '$rootScope',
        '$timeout',
        '$location',
        '$stateParams',
        '$sessionStorage',
        '$window',
        '$ihttp',
        'imHeaderService',
        'headerModel',
        'appConfig',
        'navbarService',
        'navigationHistoryService',
        function ($state, $q, $rootScope, $timeout, $location, $stateParams, $sessionStorage, $window, $ihttp, imHeaderService, headerModel, appConfig, navbarService, navigationHistoryService) {
            let lastTitle = '';
            let currentHeader = null;
            let pendingNavigation = null;
            const initialBrowserState = $window.history.state || {};
            const navigationEntry = $window.performance?.getEntriesByType?.('navigation')?.[0];
            const hasClonedBrowserHistory = navigationEntry?.type === 'back_forward' && ($sessionStorage.stateChain || []).length > 0;
            const persistedEntries = angular.copy($sessionStorage.stateChain || []);
            const hasCopiedTrailWithoutBrowserHistory = !hasClonedBrowserHistory && !initialBrowserState.ttNavigationVisitId && persistedEntries.length > 0;
            let lastBrowserPosition = hasCopiedTrailWithoutBrowserHistory ? -1 : Number(initialBrowserState.ttNavigationPosition) || 0;

            if (hasCopiedTrailWithoutBrowserHistory) {
                persistedEntries.forEach((entry) => {
                    entry.browserPosition = undefined;
                });
            }

            navigationHistoryService.hydrate({
                entries: persistedEntries,
                activeIndex: angular.isNumber($sessionStorage.stateServiceIndex) ? $sessionStorage.stateServiceIndex : undefined,
            });

            if (hasClonedBrowserHistory) {
                const snapshot = navigationHistoryService.snapshot;
                const copiedEntries = snapshot.entries.slice(0, snapshot.activeIndex + 1);
                const copiedUrls = copiedEntries.map((entry) => $state.href(entry.name, entry.parms));

                if (copiedEntries.length > 0 && copiedUrls.every((url) => !!url)) {
                    navigationHistoryService.rebaseBrowserPositions();

                    copiedEntries.forEach((entry, index) => {
                        const browserState = {
                            ...(index === copiedEntries.length - 1 ? initialBrowserState : {}),
                            ttNavigationVisitId: entry.id,
                            ttNavigationPosition: index,
                        };

                        if (index === 0) $window.history.replaceState(browserState, entry.title, copiedUrls[index]);
                        else $window.history.pushState(browserState, entry.title, copiedUrls[index]);
                    });

                    lastBrowserPosition = copiedEntries.length - 1;
                }
            }

            navigationHistoryService.stateChain$.subscribe(function () {
                const snapshot = navigationHistoryService.snapshot;
                $sessionStorage.stateChain = angular.copy(snapshot.entries);
                $sessionStorage.stateServiceIndex = snapshot.activeIndex;
                $rootScope.$broadcast('stateChainChanged');
            });

            var hasAnyProperty = function (obj) {
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) return true;
                }

                return false;
            };

            var getDefaultBackState = function () {
                var dbs = {
                    name: 'mainmenu',
                    parms: {},
                };

                if (angular.isDefined($state.current.header) && angular.isDefined($state.current.header.backButton) && angular.isDefined($state.current.header.backButton.fallback)) {
                    if (angular.isDefined($state.current.header.backButton.fallback.state)) {
                        dbs.name = $state.current.header.backButton.fallback.state;
                    }

                    if (angular.isDefined($state.current.header.backButton.fallback.parms)) {
                        dbs.parms = $state.current.header.backButton.fallback.parms;
                    }
                }

                return dbs;
            };

            var onStateChangeSuccess = async function (toState, toParms, _, __, options) {
                if (angular.isUndefined(toState)) {
                    toState = $state.current;
                    toParms = $stateParams;
                }

                // BJS 20190203
                if (toState.name === '') return;

                var path = $location.path();

                const browserState = $window.history.state || {};
                const browserVisitId = pendingNavigation?.targetId || (!pendingNavigation ? browserState.ttNavigationVisitId : undefined);
                const browserPosition = pendingNavigation?.browserPosition ?? (angular.isNumber(browserState.ttNavigationPosition) ? browserState.ttNavigationPosition : navigationHistoryService.snapshot.entries.length === 0 ? 0 : lastBrowserPosition + 1);
                const state = navigationHistoryService.recordNavigation(
                    {
                        name: toState.name,
                        pageTitle: lastTitle || '...',
                        path: path,
                        title: '',
                        state: toState,
                        parms: toParms,
                        date: new Date().toISOString(),
                        isStartup: navigationHistoryService.snapshot.entries.length === 0 && !pendingNavigation && !browserState.ttNavigationVisitId,
                    },
                    {
                        browserPosition: browserPosition,
                        replace: pendingNavigation?.replace === true,
                        visitId: browserVisitId,
                    },
                );

                lastBrowserPosition = browserPosition;
                pendingNavigation = null;
                $window.history.replaceState({ ...browserState, ttNavigationVisitId: state.id, ttNavigationPosition: browserPosition }, document.title);

                const historySnapshot = navigationHistoryService.snapshot;
                const stateChain = historySnapshot.entries;
                const index = historySnapshot.activeIndex;

                currentHeader = headerModel.build($state.current.header, $stateParams);

                console.log(currentHeader);

                var dbs = getDefaultBackState();

                // BJS 20180118 - Lagt til sjekk om verdier finnes før setCachedState for å unngå feilmeldinger i console.
                var dbsName = '';
                var dbsPath = '';

                if (angular.isDefined(dbs)) {
                    dbsName = dbs.name;
                    dbsPath = $state.href(dbs.name, dbs.parms, { absolute: true });
                }

                var chainName = '';
                var chainPath = '';

                if (index > 0 && angular.isArray(stateChain) === true && stateChain.length >= index - 1) {
                    chainName = stateChain[index - 1]?.name ?? '';
                    chainPath = stateChain[index - 1]?.path ?? '';
                }

                currentHeader.backButton.setCachedState({
                    name: index > 0 ? chainName : dbsName,
                    path: index > 0 ? chainPath : dbsPath,
                });

                if (currentHeader.text.length === 0) {
                    currentHeader.text = 'p2_m_' + toState.name;
                }

                imHeaderService.stateChanged(currentHeader);

                navbarService.setHeading(currentHeader?.text ?? '', currentHeader?.translate);
                navbarService.setHeadingVisible(currentHeader?.visible ?? true);
                navbarService.setBackButtonVisible(currentHeader?.backButton?.visible ?? false);
                navbarService.setHomeButtonVisible(currentHeader?.homeButton?.visible ?? true);

                let title = null;

                if ($state.current?.title) title = await imHeaderService.setDocumentTitle($state.current.title, true);
                else if ($state.current.title !== '') title = await imHeaderService.setDocumentTitle();

                if (title && stateChain[index] && !stateChain[index].title) navigationHistoryService.updateActiveTitle(title);

                $sessionStorage.stateChain = angular.copy(navigationHistoryService.snapshot.entries);
                $sessionStorage.stateServiceIndex = navigationHistoryService.snapshot.activeIndex;
            };

            $rootScope.$on('$stateChangeSuccess', function (_, toState, toParms, __, ___, options) {
                // BJS 20210528 - Running on timeout with 0 delay because this fixes problem
                //                where $location.path() returns the old path.
                $timeout(onStateChangeSuccess, 0, true, toState, toParms, _, __, options);
            });

            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                const pageHeading = document.querySelector('tt-page-heading');

                if (!!pageHeading) {
                    pageHeading.querySelector('span').innerText = '';
                }
                console.log('$stateChangeStart');
                console.dir(event);
            });

            onStateChangeSuccess();

            let postGoto = function (state, parms) {
                //let parmsStr = '';
                //angular.forEach(parms, function (parm) {
                //    parmsStr += parm + '/';
                //});

                //if (parmsStr.length > 0) parmsStr = parmsStr.slice(0, -1);

                $ihttp.post({
                    method: 2856,
                    parameters: {
                        state: state,
                        //parms: parmsStr
                        parms: angular.isObject(parms) ? Object.values(parms).join('/') : angular.isString(parms) ? parms : '',
                    },
                });
            };

            var go = function (to, parms, options) {
                var deferred = $q.defer();

                if (hasAnyProperty(parms) !== true) {
                    parms = undefined;
                }

                postGoto(to, parms);

                //lastTitle = angular.copy(imHeaderService.getDocumentTitle());

                //console.dir(lastTitle);

                $timeout(function () {
                    $state.go(to, parms, options).then(
                        function () {
                            deferred.resolve();
                        },
                        (reason) => {
                            console.log(reason);
                            $location.path(to);
                        },
                    );
                }, 200);

                return deferred.promise;
            };

            var setPendingNewNavigation = function (replace) {
                const currentPosition = $window.history.state?.ttNavigationPosition;
                const browserPosition = angular.isNumber(currentPosition) ? currentPosition + (replace ? 0 : 1) : lastBrowserPosition + (replace ? 0 : 1);
                pendingNavigation = { replace: replace, browserPosition: browserPosition };
            };

            var navigateToHistoryEntry = function (entry, replace) {
                if (!entry) return false;

                const currentPosition = $window.history.state?.ttNavigationPosition;
                const delta = navigationHistoryService.getBrowserDelta(entry, currentPosition);

                if (delta !== null) {
                    pendingNavigation = { targetId: entry.id, browserPosition: entry.browserPosition, replace: false };
                    $window.history.go(delta);
                } else {
                    const shouldReplace = replace === true;
                    const browserPosition = (angular.isNumber(currentPosition) ? currentPosition : lastBrowserPosition) + (shouldReplace ? 0 : 1);
                    pendingNavigation = { targetId: entry.id, browserPosition: browserPosition, replace: shouldReplace };
                    if (shouldReplace) {
                        const browserState = {
                            ...($window.history.state || {}),
                            ttNavigationVisitId: entry.id,
                            ttNavigationPosition: browserPosition,
                        };
                        const url = $state.href(entry.name, entry.parms);
                        $window.history.replaceState(browserState, entry.title, url);
                        $window.dispatchEvent(new $window.PopStateEvent('popstate', { state: browserState }));
                    } else {
                        $location.path(entry.path);
                    }
                }

                return true;
            };

            var service = {
                go: function (to, parms, options) {
                    lastTitle = imHeaderService.getCurrentHeader().text;
                    setPendingNewNavigation(options?.location === 'replace');
                    // BJS 20210217
                    if (angular.isNumber(parms) === true) {
                        parms = parms.toString();
                    }

                    if (angular.isString(parms) === true && parms.length > 0) {
                        var state = $state.get(to);

                        var parmParts = parms.split('/');
                        var urlParts = state.url.split('?')[0].split('/');

                        var toIndex = 0;

                        var _parms = {};

                        for (var i = 0; i < urlParts.length; i++) {
                            if (toIndex >= parmParts.length) break;
                            if (urlParts[i].substr(0, 1) !== ':') continue;

                            _parms[urlParts[i].substr(1)] = parmParts[toIndex];

                            toIndex++;
                        }

                        if (toIndex > 0) {
                            parms = _parms;
                        }
                    }

                    if (to !== '') return go(to, parms, options);
                },

                pinnedGo: function (url) {
                    if ($location.path() === url) {
                        onStateChangeSuccess();
                        return;
                    }
                    setPendingNewNavigation(false);
                    $location.path(url);
                },

                goBackTo: function (state) {
                    const target = navigationHistoryService.getEntry(state.id || state.date);
                    const breadcrumb = target ? navigationHistoryService.truncateAfter(target.id) : null;
                    navigateToHistoryEntry(breadcrumb, true);
                },

                signOut: function () {
                    // BJS 20240926
                    // BJS 20241128 - Added csi query parameter
                    window.location.href = '.auth/end-session' + `?csi=${appConfig.clientSessionId}`;
                },

                back: function (to) {
                    const target = navigationHistoryService.getBackTarget(angular.isDefined(to) ? to : 1);
                    if (navigateToHistoryEntry(target)) return;

                    var dbs = getDefaultBackState();
                    setPendingNewNavigation(false);
                    go(dbs.name, dbs.parms);
                },

                newTab: function (state, parms) {
                    // RHE 20220114
                    var newTabUrl = '#/' + state;

                    postGoto(state, parms);

                    if (parms) {
                        if (angular.isString(parms) && parms !== '') {
                            newTabUrl += '/' + parms;
                        } else if (angular.isObject(parms)) {
                            newTabUrl += '/' + Object.values(parms).join('/');
                        }
                    }

                    // KLN 20230906 - Timing issue, timeout fixes inconsistant new tab focus
                    $timeout(function () {
                        window.open(newTabUrl, '_blank');
                    }, 0);
                },

                getCurrentName: function () {
                    return $state.current.name;
                },

                getCurrentPath: function () {
                    return $location.path();
                },

                getHost: function () {
                    return $location.host();
                },

                setPinnedList: function (list) {
                    navigationHistoryService.setProtectedPaths((list || []).map((pin) => pin.pinned_url));
                },

                setPin: function (state, pinned) {
                    navigationHistoryService.setPathProtected(state.path, pinned === true);
                },

                setTitleOverride: function (title, translate) {
                    imHeaderService.setDocumentTitle(title, translate).then((newTitle) => {
                        if (newTitle) navigationHistoryService.updateActiveTitle(newTitle);
                    });
                },

                getCurrentStateHeader: function () {
                    return currentHeader;
                },

                stateChain$: navigationHistoryService.stateChain$,
                activeState$: navigationHistoryService.activeState$,
            };

            return service;
        },
    ]);
})();
